module.exports = __webpack_public_path__ + "img/rectangle-outline.5f9f4b45.svg";